import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/components/Index'
import salecard from '@/components/salecard'

Vue.use(Router)

let router = new Router({
    mode: 'history',
    base:'/middleschool/',
    routes: [
        {
            path: '/',
            name: 'index',
            component: Index,
            
        },
        {
            path: '/salecard',
            name: 'salecard',
            component: salecard,
            
        }
    ],
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js